export const VIEW = "VIEW";
export const MANAGE = "MANAGE";
export const DELETE = "DELETE";
export const MANAGE_USERS = "MANAGE_USERS";